import { t } from '../i18n';
import type { FC } from 'react';
import { BookOpen, ChevronRight, Hourglass, ShieldAlert } from 'lucide-react';
import { useAppStore } from '../store/useAppStore';
import { Header } from '../components/Header';

/**
 * Kurs tanlash — o'quvchi bir nechta kursda o'qiyotgan bo'lsa.
 *
 * FAQAT 2+ kursda ko'rinadi. Bitta kursda a'zolik avtomatik tanlanadi
 * (`useAppStore.resolveIdentity`) va o'quvchi to'g'ridan-to'g'ri darslar
 * ro'yxatiga tushadi — ya'ni bir kursli o'quvchi uchun ilova avvalgidek
 * qoladi, ortiqcha bosish qo'shilmaydi.
 */
export const CoursePickerPage: FC = () => {
  const { enrollments, selectCourse } = useAppStore();

  return (
    <>
      <Header />

      <main className="page stack">
        <p className="text-sm muted" style={{ marginBottom: 'var(--space-2)' }}>
          {t('Qaysi kursni ochamiz?')}
        </p>

        {enrollments.map((a) => {
          const pending = a.status === 'PENDING';
          const blocked = a.status === 'BLOCKED';

          return (
            <button
              key={a.enrollmentId}
              type="button"
              className="card lesson-row"
              style={{
                width: '100%',
                textAlign: 'left',
                cursor: 'pointer',
                opacity: blocked ? 0.6 : 1,
              }}
              onClick={() => {
                if (!a.courseId) return;
                selectCourse(a.courseId, a.groupId);
              }}
              /*
               * Bloklangan kursni ochib bo'lmaydi, lekin RO'YXATDA
               * QOLADI: yashirilsa o'quvchi "kursim yo'qolib qoldi" deb
               * o'ylaydi. Sabab ko'rinib tursa, ustoziga murojaat
               * qiladi.
               */
              disabled={blocked || !a.courseId}
            >
              <div className="spread" style={{ width: '100%' }}>
                <div style={{ minWidth: 0 }}>
                  <div className="row" style={{ gap: 'var(--space-2)' }}>
                    <BookOpen size={16} aria-hidden="true" className="muted" />
                    <span className="lesson-title">
                      {a.courseTitle || t('Kurs')}
                    </span>
                  </div>
                  <div className="lesson-meta" style={{ marginTop: 4 }}>
                    {a.groupName || t('Guruh')}
                    {a.xp > 0 && ` · ${a.xp} XP`}
                  </div>

                  {pending && (
                    <span
                      className="chip chip-warning"
                      style={{ marginTop: 'var(--space-2)' }}
                    >
                      <Hourglass size={12} aria-hidden="true" />
                      {t('Ustoz tasdiqlashini kutmoqda')}
                    </span>
                  )}
                  {blocked && (
                    <span
                      className="chip chip-danger"
                      style={{ marginTop: 'var(--space-2)' }}
                    >
                      <ShieldAlert size={12} aria-hidden="true" />
                      {t('Yopilgan — ustozingizga murojaat qiling')}
                    </span>
                  )}
                </div>

                {!blocked && (
                  <ChevronRight
                    size={18}
                    aria-hidden="true"
                    className="muted"
                    style={{ flex: 'none' }}
                  />
                )}
              </div>
            </button>
          );
        })}

        {enrollments.length === 0 && (
          <div className="empty">
            <div className="empty-title">{t('Kurs topilmadi')}</div>
            <p className="empty-text">
              {t('Ustozingizdan taklif havolasini soʻrang.')}
            </p>
          </div>
        )}
      </main>
    </>
  );
};
